export default __webpack_public_path__ + "static/media/apps@2x.6c1eec56.png";